import React, { Component } from 'react'
import includes from 'lodash/includes'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'
import { connect } from 'react-redux'
import domainUtils from '../../../../utils/routing/domain'
import selectors from '../../../../store/shared/selectors'
import fullstory from '../../../../utils/constants/fullstory'
import sendFullStoryEvent from '../../../../utils/analyticsHelpers/sendFullStoryEvent'

class FeedResult extends Component {
  static propTypes = {
    itemId: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired,
    playingVideoId: PropTypes.any,
    playVideo: PropTypes.func.isRequired,
    position: PropTypes.number.isRequired,
    result: PropTypes.any.isRequired,
    isLessThanMedium: PropTypes.bool,
  }

  render() {
    const {
      itemId,
      onClick,
      result: { credit_person, source_code, post_title, source_url },
      playingVideoId,
      playVideo,
      isLessThanMedium,
    } = this.props

    const parsedSourceUrl = source_url ? domainUtils.rootDomain(source_url) : null

    const isVideo = includes(parsedSourceUrl, 'youtu')

    const isMobile = isLessThanMedium

    const width = (isMobile && '100%') || '33.33%'

    return (
      <div
        style={{ width }}
        onClick={() => {
          if (isVideo) {
            playVideo(null)
          }
          onClick()

          const eventProperties = {
            url_str: source_code,
            title_str: post_title,
          }
          sendFullStoryEvent(fullstory.eventNames.feedContentClick, eventProperties)
        }}
      >
        <div style={{ margin: 10 }}>
          <div className="card shadow feed-item" style={{ border: '1px solid #ecf0fc' }}>
            <div
              style={{
                maxHeight: isVideo ? 500 : 300,
                overflow: 'hidden',
                position: 'relative',
                borderRadius: '0.25rem 0.25rem 0 0',
                marginTop: -2,
              }}
            >
              <div
                style={{
                  color: 'white',
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  fontSize: 10,
                  backgroundColor: '#00000047',
                  padding: '0 5px',
                }}
              >
                {credit_person}
              </div>
              <div>
                {isVideo && (
                  <div className="embed-responsive embed-responsive-16by9">
                    <ReactPlayer
                      controls
                      width="100%"
                      height="100%"
                      playing={playingVideoId === itemId}
                      url={source_code}
                      onPlay={() => {
                        playVideo(itemId)
                        const eventProperties = {
                          url_str: source_code,
                          title_str: post_title,
                        }
                        sendFullStoryEvent(fullstory.eventNames.feedContentClick, eventProperties)
                      }}
                      onEnded={() => playVideo(null)}
                    />
                  </div>
                )}
                {!includes(source_code, 'youtube') && (
                  <img
                    style={{ width: '100%', filter: 'grayscale(30%)' }}
                    src={source_code}
                    alt=""
                  />
                )}
              </div>
            </div>
            <div className="p-1">
              <span>{post_title}</span>
              <div className="text-right">
                <a href={source_url} style={{ fontSize: 10, color: 'lightgray' }}>
                  {domainUtils.rootDomain(source_url)}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLessThanMedium: selectors.isLessThanMedium(state),
})

export default connect(mapStateToProps)(FeedResult)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/components/FeedResult.js